import React from 'react';
import ReactDOM from 'react-dom';
import { withElements } from 'with-elements';
import DiscountSelector from './DiscountSelector';

// Function to initialize the React app inside a specific container
function renderAppInElement(container) {
  console.log('RENDERING APP IN ELEMENT', container)
  ReactDOM.render(
    <React.StrictMode>
      <DiscountSelector />
    </React.StrictMode>,
    container
  );
}


withElements('#DiscountSelector', async (element) => {
  //get the data from the elements
  document.addEventListener('DOMContentLoaded', () => {
    renderAppInElement(element);
  });
});
